import { Accessor, For, Match, Switch } from "solid-js";
import HubbleImage from "~/widgets/hubble_image";
import { VoucherGenerationBrandCard } from "~/components/brand_l2/voucher_generation_brand_card";
import { Product } from "~/server/types/search";
import { ButtonDarkV2 } from "~/components/login-rnr/login_rnr_code_component";
import { clientIdConfig } from "~/data/partner_config";
import { useHomeV2Context } from "./home_v2_context";
import { useWebStoreContext } from "~/context/webstore_context";

export type BrandCardProps = {
  plainLogoUrl: string;
  cardBackgroundColor: string;
  heroImageUrl?: string;
  title: string;
  brandId: string;
  logoUrl: string;
};

function BrandCard(props: BrandCardProps) {
  const { onClickBrandCard } = useHomeV2Context();
  return (
    <div
      class="w-full"
      id={`brand-card-${props.brandId}`}
      onClick={() => onClickBrandCard(props)}
    >
      <div class="w-full cursor-pointer rounded-[16px]  darkTheme:hover:border-baseDark  sm:rounded-[18px] sm:border-[2px] sm:border-baseTertiaryMedium">
        <div class="sm:h-[210px] sm:w-[358px] ">
          <VoucherGenerationBrandCard
            plainLogoUrl={props.plainLogoUrl}
            cardBackgroundColor={props.cardBackgroundColor}
            showHubbleLogo={false}
            borderClass="rounded-[14px] sm:rounded-2xl"
          />
        </div>
      </div>
    </div>
  );
}

export function BrandsListForDesktop(props: { allBrands: Product[] }) {
  return (
    <div class="flex w-full flex-col items-center justify-start gap-6 ">
      <For
        each={getSortedBrandsListForDesktop({
          allBrands: props.allBrands,
        })}
      >
        {(brandList) => (
          <div class="flex flex-row items-center justify-center gap-6">
            <For each={brandList}>
              {(brand) => (
                <BrandCard
                  cardBackgroundColor={brand.voucherProduct.cardBackgroundColor}
                  plainLogoUrl={brand.voucherProduct.plainLogoUrl}
                  title={brand.voucherProduct.title}
                  heroImageUrl={brand.voucherProduct.heroImageUrl ?? undefined}
                  brandId={brand.id}
                  logoUrl={brand.voucherProduct.logoUrl}
                />
              )}
            </For>
          </div>
        )}
      </For>
    </div>
  );
}

export function BrandsListForMobile(props: {
  allBrands: Accessor<Product[]>;
  clientId: string;
}) {
  return (
    <div class="flex w-full flex-col items-start justify-start gap-5 px-4">
      <For each={props.allBrands()}>
        {(brand) => (
          <BrandCard
            cardBackgroundColor={brand.voucherProduct.cardBackgroundColor}
            plainLogoUrl={brand.voucherProduct.plainLogoUrl}
            title={brand.voucherProduct.title}
            heroImageUrl={brand.voucherProduct.heroImageUrl ?? undefined}
            brandId={brand.id}
            logoUrl={brand.voucherProduct.logoUrl}
          />
        )}
      </For>
    </div>
  );
}

function getSortedBrandsListForDesktop(props: {
  allBrands: Product[];
}): Product[][] {
  const totalbrandsCount = props.allBrands?.length ?? 0;

  if (props.allBrands.length === 4) {
    return [props.allBrands.slice(0, 2), props.allBrands.slice(2, 4)];
  }

  const listOfBrandList: Product[][] = [];
  for (let i = 0; i < totalbrandsCount; i += 3) {
    listOfBrandList.push(props.allBrands?.slice(i, i + 3));
  }

  return listOfBrandList;
}

export function SingleBrandCard(props: { brand: Accessor<Product> }) {
  const { onClickBrandCard, isRedemptionInProgress } = useHomeV2Context();
  const { getClientId } = useWebStoreContext();

  const onClick = () =>
    onClickBrandCard(
      {
        brandId: props.brand().id,
        plainLogoUrl: props.brand().voucherProduct.plainLogoUrl,
        cardBackgroundColor: props.brand().voucherProduct.cardBackgroundColor,
        title: props.brand().voucherProduct.title,
        heroImageUrl: props.brand().voucherProduct.heroImageUrl ?? undefined,
        logoUrl: props.brand().voucherProduct.logoUrl,
      },
      true
    );

  return (
    <div class="flex w-full flex-row items-center justify-center px-3 sm:pb-[50px]">
      <div class="z-10  flex w-full flex-col gap-3 rounded-3xl border border-[#313538] bg-baseLight p-3 sm:w-max   sm:gap-4 sm:rounded-[28px] sm:p-4">
        <div
          id={`brand-card-${props.brand().id}`}
          class="w-full cursor-pointer"
          onClick={onClick}
        >
          <Switch>
            <Match
              when={
                props.brand().voucherProduct.heroImageUrl &&
                clientIdConfig.axisClientId !== getClientId()
              }
            >
              <HubbleImage
                class="aspect-[541/316]  w-full rounded-[14px] sm:h-[210px] sm:rounded-2xl"
                src={props.brand().voucherProduct.heroImageUrl!}
                alt={props.brand().voucherProduct.title}
              />
            </Match>
            <Match when={true}>
              <div class="sm:h-[210px] sm:w-[358px] ">
                <VoucherGenerationBrandCard
                  plainLogoUrl={props.brand().voucherProduct.plainLogoUrl}
                  cardBackgroundColor={
                    props.brand().voucherProduct.cardBackgroundColor
                  }
                  showHubbleLogo={false}
                  borderClass="rounded-[14px] sm:rounded-2xl"
                />
              </div>
            </Match>
          </Switch>
        </div>
        <ButtonDarkV2 onClick={onClick} isLoading={isRedemptionInProgress()}>
          Claim your gift card
        </ButtonDarkV2>
      </div>
    </div>
  );
}
